import axios from 'axios';
import { LIB_VERSION } from '../version';
var CustomHttpsClient = /** @class */ (function () {
    function CustomHttpsClient(timeout, isLegacy) {
        // Create new instance of Axios
        this._client = axios.create();
        this._client.interceptors.request.use(function (request) {
            request.headers.setContentType('application/json');
            request.timeout = timeout;
            if (!isLegacy) {
                request.headers.set('timestamp', new Date().toISOString());
                request.headers.set('client-sdk-version', LIB_VERSION);
            }
            return request;
        }, Promise.reject);
        this.post = this._client.post;
        this.get = this._client.get;
    }
    return CustomHttpsClient;
}());
export { CustomHttpsClient };
